/*@ngInject*/
const UIModalNotificationHandlerDirective = function ($rootScope, $state, $uibModal, coreConstant, coreMediator, emailNotificationOption, modalUtil) {

    let linkFunction = function ($scope, $elm, $attrs) {
        $scope.$on(coreConstant.event.SHOW_MODAL_NOTIFICATION, function (event, options, actionId) {

            modalUtil.showGenericConfirm(options).then(function () {
                // actionId is the submissionId, no actionId means submission is deleted
                if (options.isAcordUploadCompleteReviewEffectiveDate || options.isAcordUploadComplete && actionId) {
                    $state.go('submission', {submissionId: actionId});
                }
                else if (options.isAcordUploadComplete && !actionId) {
                    $state.reload();
                }
            });
        });

        $scope.$on(coreConstant.event.SHOW_EMAIL_MODAL_NOTIFICATION, function (event, message) {

            coreMediator.getNotificationEmailTemplate(message.variables.notificationName).then(function (notificationEmailTemplate) {

                let modalInstance;

                message.notificationTitle = notificationEmailTemplate.title;
                modalInstance = $uibModal.open({
                    templateUrl: '/ui/modal/emailModal/emailModal.tpl.html',
                    controller: 'emailModalController',
                    windowClass: 'genericEmailModal',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        options: function () {
                            return message;
                        }
                    }
                });

                modalInstance.result.then(function (result) {
                    let isCustom = false;
                    if (result.selection !== emailNotificationOption.NONE) {
                        isCustom = result.selection === emailNotificationOption.CUSTOM;
                        coreMediator.sendEmailNotification(result.notificationName, isCustom, result.submissionId, result.options);
                    }
                });
            });
        });
    };

    return {
        restrict: 'E',
        replace: false,
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiModalNotificationHandler', UIModalNotificationHandlerDirective);
